import styled from 'styled-components';
import { PaginationWrapper } from '../../../../ui/atoms/Pagination/style';

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 28px;
  margin-bottom: 64px;

  .b3 {
    grid-column: auto / span 12;
  }
`;

export const Card = styled.div`
  padding: 24px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  grid-column: auto / span ${({ span }) => span};

  ${PaginationWrapper} {
    padding-bottom: 0;
  }

  .stars-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
  }
`;

export const Question = styled.div`
  display: flex;
  align-items: start;

  .question {
    margin-left: 8px;
    padding-left: 8px;
    border-left: 1px solid;
  }
`;

export const AvarageBox = styled.div`
  border-radius: 16px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.bgBox};
`;

export const RatingAnswer = styled.div`
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: 174px 12px 24px 1fr 20px 26px;
  gap: 8px;
  width: 100%;

  .progressbar-wrapper {
    > div {
      min-width: 100%;
    }
  }
`;

export const OpenAnswer = styled.div`
  border-radius: 4px;
  background: #eff5fb;
  margin-bottom: 24px;
  padding: 12px 16px;
`;
